import React from 'react';
import { Link } from 'react-router-dom';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import './ResponsiveContent.css';
import Chevron from '../content/Chevron';

// ExploreLandingScreen exposes these three destinations beside its title.
const destinations = [
  ['albums', '/albums'],
  ['reviews', '/reviews'],
  ['playlists', '/lists'],
];
export default function QuickDestinations({ showChevron = false }) {
  const { t } = useWebLocale();
  return (
    <nav className="pp-explore-destinations" aria-label={t('explore')}>
      {destinations.map(([key, to]) => (
        <Link to={to} key={key}>
          {t(key)}
          {showChevron && <Chevron className="pp-destination-chevron" />}
        </Link>
      ))}
    </nav>
  );
}
